import { functions } from "common/config/Firebase";
import createPDFInvoiceUseCase from "./createPDFInvoice";
import findClientByTask from "tasks/services/sign/findClientByTask";

const sendInvoiceByEmailUseCase = async ({ invoiceData, invoiceDetail, isProforma }) => {
  // 1. Buscar datos del cliente para obtener el email
  let clientData = null;

  if (invoiceData.dniClient) {
    clientData = await findClientByTask(invoiceData.dniClient);
  }

  const to = clientData?.mail;
  if (!to) {
    throw new Error("Este cliente no tiene email configurado");
  }

  // 2. Asegurarnos de tener número de factura/proforma (si viene de la tabla, ya viene calculado)
  const num =
    invoiceData.numInvoice !== undefined && invoiceData.numInvoice !== null
      ? invoiceData.numInvoice
      : null;

  // Clon para el PDF, garantizando que numInvoice existe
  const invoiceForPdf = {
    ...invoiceData,
    numInvoice: num,
  };

  // 3. Generar + subir el PDF y obtener la URL (operación "email")
  const pdfUrl = await createPDFInvoiceUseCase({
    invoiceData: invoiceForPdf,
    initialInvoiceDetailData: { data: invoiceDetail },
    operation: "email",
    isProforma,
  });

  // 4. Llamar a la Cloud Function sendDocumentEmail
  const sendDocumentEmail = functions.httpsCallable("sendDocumentEmail");

  const safeName = (clientData?.name || "CLIENTE").trim().replace(/ /g, "_");
  const numStr = num != null ? String(num).padStart(5, "0") : "";
  const label = isProforma ? "PROFORMA" : "FACTURA";

  const filename = `${safeName}-${label}${numStr ? "-" + numStr : ""}.pdf`;

  const formatDate = (value) => {
    if (!value) return "";
    // si viene como timestamp (ms)
    if (typeof value === "number") {
      return new Date(value).toLocaleDateString("es-ES");
    }
    // si viene como Firestore Timestamp { seconds, nanoseconds }
    if (typeof value === "object" && value.seconds) {
      return new Date(value.seconds * 1000).toLocaleDateString("es-ES");
    }
    // si viene como string ya formateada
    return String(value);
  };

  const formatMoney = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    if (Number.isNaN(n)) return String(value);
    return `${n.toFixed(2).replace(".", ",")} €`;
  };

  const payload = {
    to,
    pdfUrl,
    filename,
    type: isProforma ? "proforma" : "factura",
    meta: {
      repairNumber: invoiceData.taskReference || "",
      invoiceDate: formatDate(invoiceData.invoiceDate),
      proformaDate: formatDate(invoiceData.invoiceDate),
      totalPrice: formatMoney(invoiceData.totalPrice)
    },
  };

  // Solo enviamos número cuando realmente lo tenemos
  if (!isProforma && num != null) {
    payload.meta.invoiceNumber = num;
  }

  if (isProforma && num != null) {
    payload.meta.proformaNumber = num;
  }

  const result = await sendDocumentEmail(payload);
  return result;

};

export default sendInvoiceByEmailUseCase;